import React, { Component } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import ather from '../../../assets/images/Layer.png';
import { Link } from 'react-router-dom'
import { sendLogout } from '../../../redux/Action/Login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
        this.modal = this.modal.bind(this);
    }

    modal() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    sendLogout = () => {
        this.props.sendLogout();
    }

    render() {
        return (
            <header className="header">
                <Row>
                    <Col className="text-right" lg="11">
                        {/* <Link to="/dashboard">
                            <img src={ather} width="75" alt="logo" />
                        </Link> */}
                    </Col>

                    <Col className="text-right">
                        <i style={{ cursor: "pointer", paddingTop: "1rem" }} onClick={this.modal} className="fa fa-power-off"></i>
                        <Modal isOpen={this.state.modal} toggle={this.modal} className="deleteReq">
                            <ModalHeader toggle={this.modal}>تسجيل الخروج</ModalHeader>
                            <ModalBody><h3>هل تريد الخروج ؟</h3></ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={this.sendLogout}>تاكيد</Button>{' '}
                                <Button color="secondary" onClick={this.modal}>الغاء</Button>
                            </ModalFooter>
                        </Modal>
                    </Col>
                </Row>

            </header>
        );
    }
}

const mapStateToProps = state => {
    return {
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        sendLogout,
    }
    , dispatch
)

export default (connect(mapStateToProps, mapDispatchToProps))(Header);